import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './index.css';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import ForgotPassword from './pages/ForgotPassword';
import CheckIn from './pages/CheckIn';
import Tests from './pages/Tests';
import Specialization from './pages/Specialization';
import Blefaroplastica from './pages/Blefaroplastica';
import Pterigio from './pages/Pterigio';
import Tecnologie from './pages/Tecnologie';
import Booking from './pages/Booking';
import Checkout from './pages/Checkout';
import PatientDashboard from './pages/PatientDashboard';
import CartellaClinicaNew from './pages/CartellaClinicaNew';
import DoctorDashboard from './pages/DoctorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import PatientCard from './pages/PatientCard';
import PatientDetails from './pages/PatientDetails';
import VisitView from './pages/VisitView';
import VisitaOculistica from './pages/VisitaOculistica';
import { SmartChatWidget } from './components/ChatWidget';
import CookieBanner from './components/CookieBanner';
import ChiSiamo from './pages/ChiSiamo';
import Equipe from './pages/Equipe';
import News from './pages/News';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Abbonamenti from './pages/Abbonamenti';
import FAQAbbonamenti from './pages/FAQAbbonamenti';
import ListinoPrezzi from './pages/ListinoPrezzi';
import LineeGuida from './pages/LineeGuida';
import ProtocolliStrabismo from './pages/ProtocolliStrabismo';
import Telemedicina from './pages/Telemedicina';
import Manualistica from './pages/Manualistica';
import Contatti from './pages/Contatti';
import LavoraConNoi from './pages/LavoraConNoi';
import ConfermaAppuntamento from './pages/ConfermaAppuntamento';
import EmergencyCheckout from './pages/EmergencyCheckout';
import WaitingRoom from './pages/WaitingRoom';
import CheckInPayment from './pages/CheckInPayment';
import LocationPage from './pages/LocationPage';
import Blog from './pages/Blog';
import ArticoloSingolo from './pages/ArticoloSingolo';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/login" element={<Auth />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/checkin" element={<CheckIn />} />
        <Route path="/checkin/success" element={<CheckIn />} />
        <Route path="/tests" element={<Tests />} />
        <Route path="/specialization/:category" element={<Specialization />} />
        <Route path="/blefaroplastica" element={<Blefaroplastica />} />
        <Route path="/pterigio" element={<Pterigio />} />
        <Route path="/tecnologie" element={<Tecnologie />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/prenota" element={<Booking />} />
        <Route path="/checkout/:packageId" element={<Checkout />} />
        <Route path="/checkout/success" element={<Checkout />} />
        <Route path="/checkout/emergency/:invoiceId" element={<EmergencyCheckout />} />
        <Route path="/checkout/emergency/:invoiceId/success" element={<EmergencyCheckout />} />
        <Route path="/dashboard/patient" element={<PatientDashboard />} />
        <Route path="/profile" element={<Navigate to="/dashboard/patient?tab=profile" replace />} />
        <Route path="/visita/:visitId" element={<VisitView />} />
        <Route path="/cartella-clinica/:patientId" element={<CartellaClinicaNew />} />
        <Route path="/cartella-clinica" element={<CartellaClinicaNew />} />
        <Route path="/dashboard/doctor" element={<DoctorDashboard />} />
        <Route path="/dashboard/admin" element={<AdminDashboard />} />
        <Route path="/waiting-room" element={<WaitingRoom />} />
        <Route path="/pay/checkin/:checkInId" element={<CheckInPayment />} />
        <Route path="/my-card" element={<PatientCard />} />
        <Route path="/patient/:patientId" element={<PatientDetails />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/equipe" element={<Equipe />} />
        <Route path="/news" element={<News />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/abbonamenti" element={<Abbonamenti />} />
        <Route path="/abbonamenti/faq" element={<FAQAbbonamenti />} />
        <Route path="/listino-prezzi" element={<ListinoPrezzi />} />
        <Route path="/linee-guida" element={<LineeGuida />} />
        <Route path="/protocolli-strabismo" element={<ProtocolliStrabismo />} />
        <Route path="/telemedicina" element={<Telemedicina />} />
        <Route path="/manualistica" element={<Manualistica />} />
        <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/conferma-appuntamento/:token" element={<ConfermaAppuntamento />} />
        <Route path="/visita-oculistica/:appointmentId" element={<VisitaOculistica />} />
        <Route path="/visita-oculistica" element={<VisitaOculistica />} />
        
        {/* Blog e Articoli */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/articolo/:slug" element={<ArticoloSingolo />} />
        
        {/* SEO Location Pages */}
        <Route path="/oculista-milano" element={<LocationPage />} />
        <Route path="/oculista-napoli" element={<LocationPage />} />
        <Route path="/oculista-roma" element={<LocationPage />} />
        <Route path="/location/:city" element={<LocationPage />} />
      </Routes>
      <SmartChatWidget />
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
